var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.258,
    height: 14.504,
    viewBox: "0 0 22.258 14.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51447",
    "data-name": "Group 51447",
    transform: "translate(-2.522 -19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206273",
    "data-name": "Path 206273",
    d: "M60.619,54.091a4.168,4.168,0,0,0-2.741-3.444l-.141-.047a4.728,4.728,0,0,1-2.788.914A4.676,4.676,0,0,1,52.16,50.6l-.117.047A4.194,4.194,0,0,0,49.7,52.732l.726,2.132h2.812A1.543,1.543,0,0,1,54.691,55.9l.351,1.008a1.539,1.539,0,0,1,.047.8H60.08a.832.832,0,0,0,.82-.89Z",
    transform: "translate(-36.124 -24.196)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206274",
    "data-name": "Path 206274",
    d: "M60.561,26.076A3.538,3.538,0,1,0,57,22.538,3.55,3.55,0,0,0,60.561,26.076Z",
    transform: "translate(-41.714)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206275",
    "data-name": "Path 206275",
    d: "M17.419,56.83a.328.328,0,0,0-.281-.211h-3.7l-1.757-5.108A.328.328,0,0,0,11.4,51.3H2.821a.3.3,0,0,0-.281.4L4.7,58.025a.328.328,0,0,0,.281.211H17.466a.3.3,0,0,0,.281-.4ZM8.187,55.564a.75.75,0,0,1,0-1.5.771.771,0,0,1,.75.75A.74.74,0,0,1,8.187,55.564Z",
    transform: "translate(0 -24.732)",
    fill: "#353535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/CD.52a76df8322fc30e56ccb8e3252e619c.svg";
export { ForwardRef as ReactComponent };